import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import './assets/css/reset.css'
Vue.config.productionTip = false
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
Vue.use(ElementUI);
// import echarts from 'echarts' //引入echarts
Vue.prototype.$echarts = echarts //引入组件
import  * as  echarts from 'echarts'
new Vue({
	router,
	store,
	render: h => h(App)
}).$mount('#app')
